import React, { useEffect, useState } from "react";
import axios from "axios";
import CategoriesNav from "../components/CategoriesNav";
import MainTitle from "../components/MainTitle";

const Help = () => {
  let [page, setPage] = useState([]);
  useEffect(() => {
    const fetch = async () => {
      console.log("fetching data");
      try {
        let { data } = await axios.get(process.env.REACT_APP_API_BASE_URL+"/wp/v2/pages/49");
        //console.log(data);
        setPage(data);        
      } catch (err) {
        console.error(err);
      }
    };


    fetch();

  }, []);
  
  if (!Array.isArray(page)) {
    page = [page];
  }
  console.log(page);
  return (
    
    <div>
      <MainTitle />
      <CategoriesNav />
      {page.map((el) => (
        <article key={el.id} className="shadow p-3 mb-5 bg-body rounded">
          <h2>
            { el.title.rendered }
          </h2>
          {/* <p>{el.content.rendered.replace(/<[^>]+>/g, '')}</p> */}
          <div dangerouslySetInnerHTML={{__html: (el.content.rendered)}} className="py-3" />
        </article>
      ))}
    </div>  
  );
};





export default Help;